// extracted by mini-css-extract-plugin
export default {"Swiper":"Slider_Swiper__oLa7o"};